<div class="pill-list flex flex-nowrap gap-1 align-items-center">
  @for (item of visibleItems(); track item.id) {
    <ng-container
      *ngTemplateOutlet="pill; context: { $implicit: item }"></ng-container>
  }
  @if (hiddenCount() > 0) {
    <p-tag
      class="flex-shrink-0"
      styleClass="pill-more px-2 cursor-pointer"
      [value]="'+' + hiddenCount()"
      [rounded]="true"
      pTooltip="Alle anzeigen"
      (click)="overlay.toggle($event); $event.stopPropagation()"></p-tag>
  }
</div>

<p-overlayPanel #overlay styleClass="pill-list-overlay">
  <div class="flex flex-wrap gap-1">
    @for (item of allItems(); track item.id) {
      <ng-container
        *ngTemplateOutlet="
          pill;
          context: { $implicit: item, overlay: overlay }
        "></ng-container>
    }
  </div>
</p-overlayPanel>

<ng-template #pill let-item let-overlay="overlay">
  <p-tag
    class="pill min-w-0"
    styleClass="px-2 cursor-pointer"
    [icon]="item.icon"
    [value]="item.label"
    [rounded]="true"
    [pTooltip]="itemTooltip() ? item.label + ': ' + itemTooltip() : item.label"
    (click)="onItemClick(item.id, $event); overlay?.hide()"></p-tag>
</ng-template>
